import React from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { Upload, Button } from 'antd';
import { FILE_URL } from '../../constants/file';
import PropTypes from 'prop-types';
import { getCsrfCookie } from '../../utils/cookieUtil';

export default class FileUpload extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  };

  render() {
    const propsUpload = {
      action: FILE_URL,
      headers: {
        'X-XSRF-TOKEN': getCsrfCookie(),
      },
    };

    const { t, disabled } = this.props;

    return (
      <Upload {...propsUpload} {...this.props}>
        <Button disabled={disabled || false}>
          <UploadOutlined /> {t('button_upload')}
        </Button>
      </Upload>
    );
  }
}
